import type { MutableRefObject, ChangeEvent, KeyboardEvent } from "react";

import useToggle from 'hooks/useToggle';
import eyeOpenedIcon from 'images/step2/modalSignUp/eyeOpened.svg';
import eyeClosedIcon from 'images/step2/modalSignUp/eyeClosed.svg';
import { Div } from './elements';

type Props = {
  reference: MutableRefObject<HTMLInputElement | null>;
  id: string;
  placeholder: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onKeyUp: (e: KeyboardEvent<HTMLInputElement>) => void;
}

const InputPassword = ({ onChange, placeholder, onKeyUp, reference, id, value }: Props) => {
  const [show, toggle] = useToggle(false);
  return (
    <Div>
      <input
        ref={reference}
        id={id}
        name={id}
        aria-label='Password'
        type={show? 'text': 'password'}
        placeholder={placeholder}
        className={value.length > 2? '': 'empty'}
        value={value}
        onKeyUp={onKeyUp}
        onChange={onChange}/>
      {value && (
        <button onClick={toggle}>
          <img
            src={show? eyeOpenedIcon: eyeClosedIcon}
            alt={show? 'Hide': 'Show'} />
        </button>
      )}
    </Div>
  );
};

export default InputPassword;
